module.exports = __webpack_public_path__ + "static/icons/icon-email-a3c91bfd95017fddda084bacefe08ae7.svg";